// ==================== MODAL DE CONFIRMACIÓN DE ELIMINACIÓN ====================
// Modal con doble verificación para eliminar usuarios

import React, { useState } from 'react';
import '../../estilos/ConfirmDeleteModal.css';

const ConfirmDeleteModal = ({ usuario, estadisticas, onConfirm, onCancel }) => {
  const [confirmacionTexto, setConfirmacionTexto] = useState('');
  const [aceptoCondiciones, setAceptoCondiciones] = useState(false);

  const textoValido = confirmacionTexto === 'ELIMINAR';
  const puedeEliminar = textoValido && aceptoCondiciones;

  const handleConfirm = () => {
    if (puedeEliminar) {
      onConfirm();
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      onCancel();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-contenido" onClick={(e) => e.stopPropagation()}>
        
        {/* Encabezado de advertencia */}
        <div className="modal-header-peligro">
          <span className="icono-advertencia">⚠️</span>
          <h2>¡ADVERTENCIA! Acción Irreversible</h2>
        </div>

        {/* Información del usuario */}
        <div className="usuario-info-eliminar">
          <h3>Vas a eliminar al usuario:</h3>
          <div className="usuario-datos">
            <p><strong>Nombre:</strong> {usuario.nombre}</p>
            <p><strong>Email:</strong> {usuario.email}</p>
            <p><strong>Rol:</strong> {usuario.rol}</p>
          </div>
        </div>

        {/* Estadísticas de lo que se eliminará */}
        <div className="estadisticas-eliminacion">
          <h3>Se eliminarán permanentemente:</h3>
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-numero">{estadisticas.proyectos || 0}</span>
              <span className="stat-label">Proyectos</span>
            </div>
            <div className="stat-item">
              <span className="stat-numero">{estadisticas.subcontratos || 0}</span>
              <span className="stat-label">Subcontratos</span>
            </div>
            <div className="stat-item">
              <span className="stat-numero">{estadisticas.materiales || 0}</span>
              <span className="stat-label">Materiales</span>
            </div>
            <div className="stat-item">
              <span className="stat-numero">{estadisticas.documentos || 0}</span>
              <span className="stat-label">Documentos</span>
            </div>
            <div className="stat-item">
              <span className="stat-numero">{estadisticas.miembrosEquipo || 0}</span>
              <span className="stat-label">Miembros Equipo</span>
            </div>
            <div className="stat-item">
              <span className="stat-numero">{estadisticas.total || 0}</span>
              <span className="stat-label">Total Elementos</span>
            </div>
          </div>
        </div>

        {/* Advertencia crítica */}
        <div className="advertencia-critica">
          <p>
            <strong>⚠️ IMPORTANTE:</strong> Esta acción eliminará permanentemente al usuario 
            y TODOS sus datos asociados. No hay forma de recuperar esta información después de eliminada.
          </p>
        </div>

        {/* Checkbox de confirmación */}
        <div className="confirmacion-checkbox">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={aceptoCondiciones}
              onChange={(e) => setAceptoCondiciones(e.target.checked)}
            />
            <span>Entiendo que esta acción es irreversible y he revisado los datos a eliminar</span>
          </label>
        </div>

        {/* Input de verificación */}
        <div className="verificacion-texto">
          <label>
            Para confirmar, escribe <strong>ELIMINAR</strong> en el campo:
          </label>
          <input
            type="text"
            value={confirmacionTexto}
            onChange={(e) => setConfirmacionTexto(e.target.value)}
            placeholder="Escribe ELIMINAR"
            className={textoValido ? 'input-valido' : ''}
          />
        </div>

        {/* Botones de acción */}
        <div className="modal-acciones">
          <button
            className="btn-cancelar"
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button
            className={`btn-eliminar ${!puedeEliminar ? 'disabled' : ''}`}
            onClick={handleConfirm}
            disabled={!puedeEliminar}
          >
            Eliminar Usuario Permanentemente
          </button>
        </div>

      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
